import { createSlice } from '@reduxjs/toolkit'

const getStoredUser = () => {
  try {
    const user = localStorage.getItem('user')
    return user ? JSON.parse(user) : null
  } catch (error) {
    return null
  }
}

const initialState = {
  user: getStoredUser(),
  token: localStorage.getItem('access_token') || null,
  orgId: localStorage.getItem('org_id') || null,
  userType: localStorage.getItem('user_type') || null,
  isAuthenticated: !!localStorage.getItem('access_token'),
  loading: false,
  error: null,
  permissions: JSON.parse(localStorage.getItem('permissions') || '[]'),
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { user, token, access_token, org_id, user_type, permissions } = action.payload

      // Handle both formats: direct token or access_token from API
      const authToken = token || access_token

      // Normalize user role: "super_admin" -> "superadmin" for frontend consistency
      const normalizedUser = user ? {
        ...user,
        role: user.role === 'super_admin' ? 'superadmin' : user.role
      } : user

      // Determine user_type from user.role if not provided directly
      const userType = user_type || (user?.role === 'super_admin' ? 'superadmin' : user?.role)

      state.user = normalizedUser
      state.token = authToken
      state.orgId = org_id
      state.userType = userType
      state.isAuthenticated = true
      state.permissions = permissions || []

      // Store in localStorage
      localStorage.setItem('access_token', authToken)
      localStorage.setItem('user', JSON.stringify(normalizedUser))
      localStorage.setItem('user_type', userType)
      if (org_id) localStorage.setItem('org_id', org_id)
      if (permissions) localStorage.setItem('permissions', JSON.stringify(permissions))
    },
    logout: (state) => {
      state.user = null
      state.token = null
      state.orgId = null
      state.userType = null
      state.isAuthenticated = false
      state.permissions = []

      // Clear localStorage
      localStorage.removeItem('access_token')
      localStorage.removeItem('user')
      localStorage.removeItem('user_type')
      localStorage.removeItem('org_id')
      localStorage.removeItem('permissions')

      // Clear session storage
      sessionStorage.clear()
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload }
      localStorage.setItem('user', JSON.stringify(state.user))
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    clearError: (state) => {
      state.error = null
    },
  },
})

export const {
  setCredentials,
  logout,
  updateUser,
  setLoading,
  setError,
  clearError,
} = authSlice.actions

export default authSlice.reducer